module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/pencil-2e0ec4d75b9ca7893b5055bdedaaa556.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/pencil.svg
// module id = 8zwS
// module chunks = 24